import React, { useState, useEffect } from "react";
import "../../css/search.scss";
import "../../css/sidebar.scss";
import { useNavigate } from "react-router";

import { MenuOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faEdit,
  faMagnifyingGlass,
  faUser,
} from "@fortawesome/free-solid-svg-icons";

import ChatBot from "../../components/chatBot/chatBot";
import { Input, Menu, Tabs, Button } from "antd";
import { getSessionId } from "../../helper/utils";
// import VoiceAgent from "../../components/VoiceAgent/VoiceAgent";
import ConvaiWidget from "../../components/ConvaiWidget/ConvaiWidget";
import useChatWidget from "../../customHook/useChatWidget";


const { Search } = Input;
const { TabPane } = Tabs;

export default function Home() {
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const toggleSidebar = () => setSidebarVisible((prev) => !prev);
  const navigate = useNavigate();

  const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);
  const toggleSidebarCollapse = () => setSidebarCollapsed((prev) => !prev);

  const [isChatBotVisible, setChatBotVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("supabase");

  useEffect(() => {
    document.body.classList.add("static-chat");
    return () => {
      document.body.classList.remove("static-chat");
    };
  }, []);

  useEffect(() => {
    setChatBotVisible(true);
    getSessionId(true);
  }, []);

  const handleTabChange = (key) => {
    setActiveTab(key);
    if (key === 'talha') {
      navigate('/voice');
    }
  };

  const [suggestions] = useState([
    "bags",
    "jeans",
    "Red polo shirts",
    "Discover jackets",
    "Trending sunglasses",
  ]);
  const [currentSuggestion, setCurrentSuggestion] = useState(suggestions[0]);
  const [inputValue, setInputValue] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [isSliding, setIsSliding] = useState(false);

  useEffect(() => {
    if (isTyping) return;
    let index = 0;
    const interval = setInterval(() => {
      setIsSliding(true);
      setTimeout(() => {
        setCurrentSuggestion(suggestions[index]);
        setIsSliding(false);
        index = (index + 1) % suggestions.length;
      }, 500);
    }, 2500);
    return () => clearInterval(interval);
  }, [isTyping, suggestions]);

  useChatWidget(activeTab);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setIsTyping(value !== "");
  };

  const handleInputFocus = () => setIsTyping(inputValue !== "");
  const handleInputBlur = () => {
    if (inputValue === "") setIsTyping(false);
  };

  return (
    <>
      <div className="layout-main">
        {/* <VoiceAgent /> */}

        {/* {activeTab === "supabase" && ( */}
        {/* <ConvaiWidget /> */}
        {/* )} */}

        <div
          className={`sidebar-main ${isSidebarVisible ? "visible" : ""} ${isSidebarCollapsed ? "collapsed" : ""
            }`}
        >
          <div className="top-data">
            <div className="logo-hd-main">
              <div className="logo-hd">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-text"
                  stroke="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9711 4.90751C10.8931 4.64523 10.7206 4.5 10.4839 4.5C10.2471 4.49956 10.0715 4.64388 9.99619 4.90617C9.77236 5.68628 9.55168 6.46787 9.32794 7.24798C8.61425 9.73641 7.04152 11.4147 4.58927 12.2337C3.70977 12.5272 2.80719 12.7524 1.91414 13.0062C1.72111 13.0612 1.55261 13.1377 1.5 13.3561V13.6353C1.54814 13.8449 1.70863 13.9285 1.89273 13.9812C2.68611 14.2073 3.48101 14.4281 4.27322 14.6582C6.68445 15.3578 8.34098 16.8815 9.17323 19.2578C9.49804 20.1848 9.72555 21.1412 9.99484 22.0848C10.0501 22.2783 10.1268 22.4471 10.3443 22.5H10.6221C10.8302 22.4508 10.9149 22.2913 10.9676 22.1062C11.1922 21.3182 11.4147 20.5298 11.6389 19.7417C12.3173 17.3561 13.8027 15.6965 16.1297 14.8476C17.0886 14.4977 18.0911 14.2681 19.0732 13.9817C19.3465 13.9021 19.4931 13.7345 19.4998 13.5071C19.5065 13.2775 19.3505 13.0911 19.0732 13.0112C18.2884 12.7847 17.5021 12.5615 16.7163 12.3378C14.3876 11.6747 12.7498 10.2287 11.8742 7.96423C11.4914 6.97378 11.2742 5.92613 10.9711 4.90751Z"
                    fill="black"
                  />
                </svg>
              </div>
              <span className="toggle-arrow" onClick={toggleSidebarCollapse}>
                <FontAwesomeIcon
                  icon={isSidebarCollapsed ? faArrowRight : faArrowLeft}
                  className="home-icon"
                />
              </span>
              <span className="close-sidebar-btn" onClick={toggleSidebar}>
                ×
              </span>
            </div>
 <div className="ai-header-right bots-tabs-main">
  
 </div>
        

            <Menu
              className="sidebar-menu"
              mode="inline"
              defaultOpenKeys={["home"]}
              defaultSelectedKeys={[""]}
              motion={false}
            >
              <Menu.Item
                key="newChat"
                icon={
                  <FontAwesomeIcon
                    className="home-icon"
                    style={{ fontSize: 16 }}
                    icon={faUser}
                  />
                }
                onClick={()=>{
                  handleTabChange("supabase");
                  toggleSidebar()
                }}
              >
                DL1961
              </Menu.Item>
              <Menu.Item
                key="searchChat"
                icon={
                  <FontAwesomeIcon
                    className="ai-icon"
                    style={{ fontSize: 16 }}
                  icon={faUser}
                  />
                }
                onClick={()=>{
                  handleTabChange("arham");
                toggleSidebar();
                }}
              >
               Yensa
              </Menu.Item>
              {/* <Menu.Item
                className="d-block d-lg-none"
                key="TeamA"
                icon={
                  <FontAwesomeIcon
                    className="ai-icon"
                    style={{ fontSize: 16 }}
                    icon={faUser}
                  />
                }
                onClick={() => {
                  setActiveTab("supabase");
                  setSidebarVisible(false);
                }}
              >
                Team A (Araj - Supabase)
              </Menu.Item> */}

              {/* <Menu.Item
               disabled={true}
                className="d-block d-lg-none"
                key="TeamA2"
                icon={
                  <FontAwesomeIcon
                    className="ai-icon"
                    style={{ fontSize: 16 }}
                    icon={faUser}
                  />
                }
                onClick={() => {
                  setActiveTab("Postgres");
                  setSidebarVisible(false);
                }}
              >
                Team A (Araj - Postgres)
              </Menu.Item> */}

              {/* <Menu.Item
                className="d-block d-lg-none"
                key="TeamB"
                icon={
                  <FontAwesomeIcon
                    className="ai-icon"
                    style={{ fontSize: 16 }}
                    icon={faUser}
                  />
                }
                onClick={() => {
                  setActiveTab("arham");
                  setSidebarVisible(false);
                }}
              >
                Team B (Arham)
              </Menu.Item> */}

              {/* <Menu.Item
                disabled={true}
                className="d-block d-lg-none"
                key="TeamC"
                icon={
                  <FontAwesomeIcon
                    className="ai-icon"
                    style={{ fontSize: 16 }}
                    icon={faUser}
                  />
                }
                onClick={() => {
                  setActiveTab("talha");
                  setSidebarVisible(false);
                }}
              >
                Team C (Talha)
              </Menu.Item> */}

            </Menu>
          </div>
        </div>

        <div className="right-area">
          <div className="ai-header">
            <div className="ai-header-left">
              <span className="menu-toggle" onClick={toggleSidebar}>
                <MenuOutlined style={{ fontSize: "20px" }} />
              </span>
            </div>

            <div className="logo-hd-ai">Agent Zena - Version 3</div>

            <div className="ai-header-right bots-tabs-main">
              <Tabs
                activeKey={activeTab}
                onChange={handleTabChange}

                tabBarStyle={{ marginBottom: 0 }}
                className="chatbot-tabs d-none d-lg-block"
              >
                <TabPane
                  tab={
                    <span
                      className={
                        activeTab === "supabase" ? "active-tab" : "inactive-tab"
                      }
                    >
                      DL1961


                    </span>
                  }
                  key="supabase"
                />

                <TabPane

                  tab={
                    <span
                      className={
                        activeTab === "arham" ? "active-tab" : "inactive-tab"
                      }
                    >
                      Yensa

                    </span>
                  }
                  key="arham"
                />

              </Tabs>
            </div>
          </div>

          <div className="content-wrapper">
            {isChatBotVisible && (
              <ChatBot
                setChatBotVisible={setChatBotVisible}
                source={activeTab}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
